import axios from './axios';

export default {

  getAllPromotions: async () => {
    let url = `${process.env.REACT_APP_API_URL}/product/promotions`; 
    return await axios.get(url);
  },

}